<template>
  <footer style="bottom: 0" class="d-flex flex-wrap justify-content-between align-items-center mt-3 py-1 border-top">
    <div class="col-md-4 d-flex align-items-center mt-3">
      <span class="mb-3 mb-md-0 text-muted">&copy; 2023 QNBpay - Tüm Hakları Saklıdır.</span>
    </div>
  </footer>
</template>
